// React hook for components that need to read the current session.
//
// Built on useSyncExternalStore (React 18+) — the canonical pattern
// for subscribing components to a mutable external store. Returns the
// current snapshot; re-renders the consumer whenever the store
// notifies a change.

import { useSyncExternalStore } from "react";
import { currentSession, subscribe } from "../api/sessionStore";

export function useSession() {
  return useSyncExternalStore(subscribe, currentSession, () => null);
}
